export default __webpack_public_path__ + "static/media/photography_film.438b2c04.jpg";